import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IStore } from '../../reducers';

const PremiumTimer = () => {
  const expiresAt = useSelector((state: IStore) => state.features.expiresAt);

  // Calculate the remaining time from validity_at
  const calculateTimeDifference = (timeStr: string) => {
    const targetDate = new Date(timeStr);
    const currentDate = new Date();
    const differenceInSeconds = Math.round(
      (targetDate.getTime() - currentDate.getTime()) / 1000
    );

    return Math.max(0, differenceInSeconds); // Ensure we don't return negative values
  };

  const [remainingSeconds, setRemainingSeconds] = useState(
    calculateTimeDifference(expiresAt)
  );

  useEffect(() => {
    if (remainingSeconds === 0) {
      return; // No need to start the interval if already expired
    }

    const timerId = setInterval(() => {
      setRemainingSeconds((prevSeconds) => {
        if (prevSeconds > 0) {
          return prevSeconds - 1;
        }

        clearInterval(timerId); // Clear the interval if time's up
        return 0;
      });
    }, 1000);

    return () => clearInterval(timerId); // Clear the interval on component unmount
  }, [remainingSeconds]);

  const days = Math.floor(remainingSeconds / 86400);
  const hours = Math.floor((remainingSeconds - days * 86400) / 3600);
  const minutes = Math.floor(
    (remainingSeconds - days * 86400 - hours * 3600) / 60
  );
  const seconds = remainingSeconds - days * 86400 - hours * 3600 - minutes * 60;

  let phrase = `${seconds}s`;
  if (minutes > 0) {
    phrase = `${minutes}m ${seconds}s`;
  }
  if (hours > 0) {
    phrase = `${hours}h ${minutes}m ${seconds}s`;
  }
  if (days > 0) {
    phrase = `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  return (
    <>
      {!remainingSeconds
        ? 'Premium is not activated'
        : `Premium expires in ${phrase}`}
    </>
  );
};

export default PremiumTimer;
